// Reglamento WRPF Argentina — keep in sync with packages/api/src/openlifter/wrpf-rules.ts

export const WRPF_DIVISIONS = [
  "J14-16",
  "J17-19",
  "J20-23",
  "Open",
  "M40-49",
  "M50-59",
  "M60-69",
  "M70-79",
  "M80+",
] as const;

export const WRPF_WEIGHT_MEN = [52, 56, 60, 67.5, 75, 82.5, 90, 100, 110, 125, 140] as const;

export const WRPF_WEIGHT_WOMEN = [44, 48, 52, 56, 60, 67.5, 75, 82.5, 90] as const;

export const wrpfArgentinaMeetDefaults = {
  federation: "WRPF Argentina",
  divisions: [...WRPF_DIVISIONS],
  weightClassesKgMen: [...WRPF_WEIGHT_MEN],
  weightClassesKgWomen: [...WRPF_WEIGHT_WOMEN],
  weightClassesKgMx: [...WRPF_WEIGHT_MEN],
  formula: "Wilks" as const,
  ageCoefficients: "FosterMcCulloch" as const,
  wrapsOnlyAffectSquat: true,
  combineSleevesAndWraps: false,
  combineSingleAndMulti: false,
  allow4thAttempts: true,
};

/** @deprecated Use wrpfArgentinaMeetDefaults */
export const wrpfMeetDefaults = wrpfArgentinaMeetDefaults;
